<template>
  <div
    class="overflow-hidden rounded-xl border"
    :class="[
      mode === 'dark'
        ? 'border-dark-border bg-dark-sidebar'
        : 'border-border-10 bg-white-100',
      isHidden ? 'xl:hidden' : '',
    ]"
  >
    <div class="without-scrollbar overflow-x-auto">
      <table class="table" :class="[mode === 'dark' ? 'dark-table' : '']">
        <thead>
          <tr>
            <th
              v-for="(column, key) in columns"
              :key="key"
              :class="column.classes"
              :aria-sort="ariaSort(column)"
            >
              <button
                v-if="column.sortKey"
                type="button"
                class="group flex items-center gap-1.5 text-left uppercase tracking-wider transition-colors duration-200 hover:text-primary-100"
                :class="[sortKey === column.sortKey ? 'text-primary-100' : '']"
                @click="$emit('sort', column.sortKey)"
              >
                <span>{{ column.name }}</span>
                <ChevronUp
                  v-if="sortKey === column.sortKey && sortOrder === 'asc'"
                  :size="14"
                  :stroke-width="2.25"
                />
                <ChevronDown
                  v-else-if="sortKey === column.sortKey && sortOrder === 'desc'"
                  :size="14"
                  :stroke-width="2.25"
                />
                <ChevronsUpDown
                  v-else
                  :size="14"
                  :stroke-width="1.75"
                  class="opacity-40 transition-opacity duration-200 group-hover:opacity-100"
                />
              </button>
              <span v-else-if="column.name">{{ column.name }}</span>
              <span v-else>
                <slot v-if="$slots.checkbox" name="checkbox" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <slot name="rows" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-vue-next";

export default {
  name: "Table",
  components: {
    ChevronDown,
    ChevronUp,
    ChevronsUpDown,
  },
  props: {
    mode: String,
    // Columns carrying a `sortKey` render as a sort button and emit "sort"
    // with that key when clicked.  Columns without one are unchanged.
    columns: {
      type: Array,
      default: () => [
        {
          name: "",
          classes: "",
        },
      ],
    },
    isHidden: {
      type: Boolean,
      default: true,
    },
    sortKey: {
      type: String,
      default: null,
    },
    sortOrder: {
      type: String,
      default: null,
    },
  },
  emits: ["sort"],
  methods: {
    ariaSort(column) {
      if (!column.sortKey) return null;
      if (this.sortKey !== column.sortKey || !this.sortOrder) return "none";
      return this.sortOrder === "asc" ? "ascending" : "descending";
    },
  },
};
</script>
